export function isValidUrlPathString(str: string): boolean {
  // URLのパスに許可される英数字文字、ハイフン、アンダースコア、スラッシュの正規表現
  const urlPathRegex = /^[A-Za-z0-9\-_\/]+$/;
  return urlPathRegex.test(str);
}

export function isValidUrlPathComponentString(str: string): boolean {
  // URLのパスコンポーネントに許可される英数字文字、ハイフン、アンダースコアの正規表現
  const urlPathComponentRegex = /^[A-Za-z0-9\-_]+$/;
  return urlPathComponentRegex.test(str);
}

export function toCamelCase(str: string): string {
  return str
    .replace(/_./g, match => match.charAt(1).toUpperCase())
    .replace(/-./g, match => match.charAt(1).toUpperCase());
}

export function toSnakeCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .toLowerCase();
}

export function makeUrlParams(params: Record<string, string | undefined | null>): URLSearchParams {
  const result = new URLSearchParams();
  for (const key in params) {
    const value = params[key];
    if (value !== undefined && value !== null) {
      result.append(key, value);
    }
  }
  return result;
}

export function randomString(length: number): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
